"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.safetyPartnerKey = exports.clientBaseURL = exports.baseUrl = void 0;

var _ssr = require("./ssr");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var mockKey = '00000000000';
var safetyPartnerKey = _ssr.isSSR ? mockKey : window.API_KEY;
/**
 * Формирует урл для доступа к апи
 * @example https://api.level.travel | https://api.staging-alpha.level.travel | https://api.leveltravel.dev
 */

exports.safetyPartnerKey = safetyPartnerKey;

var baseUrl = function getBaseUrl() {
  if (_ssr.isSSR) return '';

  var _window$location$host = window.location.host.split(window.ENV_DOMAIN),
      _window$location$host2 = _slicedToArray(_window$location$host, 1),
      subdomains = _window$location$host2[0];

  var stagging = subdomains.split('.').filter(function (subdomain) {
    return /staging/.test(subdomain);
  }).toString();
  var result = ['https://api', stagging, window.ENV_DOMAIN || 'level.travel'].filter(Boolean).join('.');
  return result;
}();

exports.baseUrl = baseUrl;

var clientBaseURL = function () {
  var _window$location$orig;

  if (_ssr.isSSR) return '';
  return (_window$location$orig = window.location.origin) !== null && _window$location$orig !== void 0 ? _window$location$orig : "https://".concat(window.ENV_DOMAIN);
}();

exports.clientBaseURL = clientBaseURL;